<template>
  <div class="history-screen-container">
    <div class="history-screen-content main-container">
      <main-text-block :main-paragraph="mainParagraph"
                       v-animateonscroll="{ enterClass: 'fade-in'}"
                       :main-title="mainTitle"/>
      <div class="orange-title"
           v-animateonscroll="{ enterClass: 'fade-in'}">
        {{ yearTitle }}
      </div>
    </div>
    <div class="bg-container">
      <img :src="getUrl('history.webp')" alt="main-bg">
    </div>
  </div>
</template>

<script>
import MainTextBlock from "@/components/entities/blocks/MainTextBlock.vue";

export default {
  name: "HistoryScreen",
  components: {MainTextBlock},
  data() {
    return {
      yearTitle: '2008',
      mainTitle: "История нашей компании",
      mainParagraph: "Lorem ipsum dolor sit amet consectetur. Duis ac nulla quis semper molestie adipiscing proin. Cursus sit nisl etiam facilisis mauris volutpat risus. Eget quis id cras viverra tortor. Justo natoque.\n\nSit id eu elementum a ac facilisis eu pellentesque nisl. Pellentesque sit sapien nulla risus leo quam.Lorem ipsum dolor sit amet consectetur. Sit id eu elementum a ac facilisis eu pellentesque nisl. "
    }
  }
}
</script>

<style scoped lang="scss">
  .history-screen-container {
    position: relative;
    width: 100%;
    .history-screen-content {
      flex-direction: column;
      position: relative;
      z-index: 1;
      .orange-title {
        align-self: flex-end;
      }
    }
    .bg-container{
      width: 100%;
    }
  }

  @media (max-width: 3024px){
    .history-screen-container {
      .history-screen-content {
        row-gap: 375px;
        padding-top: 140px;
        padding-bottom: 110px;
        .main-block-container{
          max-width: 600px;

          &:deep(.main-paragraph-container) {
            max-width: 528px;
          }
        }
        .orange-title {
          font-size: 72px;
        }
      }
    }
  }


  @media (max-width: 2100px) {
    .history-screen-container {
      .history-screen-content {
        row-gap: 305px;
        padding-top: 128px;
        padding-bottom: 98px;
      }
    }
  }

  @media (max-width: 1920px) {
    .history-screen-container {
      .history-screen-content {
        row-gap: 245px;
        padding-top: 120px;
        padding-bottom: 110px;
        .main-block-container{
          max-width: 600px;

          &:deep(.main-paragraph-container) {
            max-width: 500px;
          }
        }
        .orange-title {
          font-size: 54px;
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .history-screen-container {
      .history-screen-content {
        row-gap: 234px;
        padding-top: 100px;
        padding-bottom: 72px;
        .main-block-container{
          max-width: 500px;

          &:deep(.main-paragraph-container) {
            max-width: 480px;
          }
        }
        .orange-title {
          font-size: 40px;
        }
      }
    }
  }
  @media (max-height: 800px) {
    .history-screen-container {
      .history-screen-content {
        padding-top: 90px;
        padding-bottom: 50px;
        .main-block-container{
          max-width: 450px;

          &:deep(.main-paragraph-container) {
            max-width: 480px;
          }
        }
        .orange-title {
          font-size: 32px;
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {

    .history-screen-container {
      .history-screen-content {
        padding-top: 100px;
        padding-bottom: 72px;
        .main-block-container{
          max-width: 500px;

          &:deep(.main-paragraph-container) {
            max-width: 480px;
          }
        }
        .orange-title {
          font-size: 40px;
        }
      }
    }
  }

  @media (max-width: 1133px) {

    .history-screen-container {
      .history-screen-content {
        padding-top: 90px;
        padding-bottom: 50px;
        .main-block-container{
          max-width: 450px;

          &:deep(.main-paragraph-container) {
            max-width: 480px;
          }
        }
        .orange-title {
          font-size: 32px;
        }
      }
    }
  }
  @media (max-width: 769px) {
    .history-screen-container {
      height: var(--calc-height);
      .history-screen-content {
        justify-content: flex-start;
        padding-top: 80px;
        padding-bottom: 0;
        row-gap: 0;
        .main-block-container{
          max-width: 100%;

          &:deep(.main-paragraph-container) {
            margin-top: 24px;
            max-width: 100%;
          }
        }
        .orange-title {
          align-self: flex-start;
          margin-top: 28px;
          font-size: 28px;
        }
      }
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .history-screen-container {
      .history-screen-content {
        row-gap: 570px;
        padding-top: 280px;
        padding-bottom: 150px;
        .main-block-container{
          max-width: 1200px;

          &:deep(.main-paragraph-container) {
            max-width: 1080px;
          }
        }
        .orange-title {
          font-size: 120px;
        }
      }
    }
  }

</style>